import { ContentType, DirectionType } from "./enums";

export class InterfaceFilterRequest {
    keywords: string = "";
    interfaceDirection: DirectionType | null = null;
    fromDate: string | null = null;
    tillDate: string | null = null;
    content: ContentType | null = null;
    status: boolean | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
}

export class InterfaceResponse {
    id = 0;
    fileName: string = "";
    filePath: string = "";
    creationDate: string | null = "";
    userFullName: string = "";
    status: boolean = false;
    interfaceDirection: string = "";
    content: string = "";
    errorLink: string | null = null;
    errors: string | null = null;
}

export interface GetInterfacesResponse {
    hasNext: boolean;
    rows: InterfaceResponse[];
    totalFilter: number;
    total: number;
}

export class InterfaceTransactionFilterRequest {
    interfaceId: number = 0;
    keywords: string = "";
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
}

export class InterfaceTransactionResponse {
    id = 0;
    employeeNumber: string = "";
    employeeName: string = "";
    username: string = "";
    createdAt: string | null = "";
    updatedExpirationDate: string | null = "";
    amount: number = 0;
    currencyId: number = 0;
    transactionType: string = "";
}

export interface GetInterfaceTransactionResponse {
    hasNext: boolean;
    rows: InterfaceTransactionResponse[];
}
